import { appendQueryParams } from '@bpm-web-app/utils';
import { Giveaway } from '@bpm-web-app/supreme-api-sdk';
import styles from './contests-grid.module.css';
import { AppLink } from '../shared/app-link/app-link';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ContestsGridProps {
    contests: Giveaway[];
}

export function ContestsGrid({ contests }: ContestsGridProps) {
    return (
        <div className={styles['contests-grid']}>
            {contests.map((contest: any) => (
                <AppLink key={contest.id} href={`/giveaway/${contest.slug}`}>
                    <a className={styles['contests-grid__contest']}>
                        <div className={styles['contests-grid__contest-image-wrapper']}>
                            <img
                                src={appendQueryParams(contest.artwork_url, { key: 'dw', value: 264 })}
                                srcSet={`${appendQueryParams(contest.artwork_url, { key: 'dw', value: 528 })} 2x`}
                                alt={contest.title}
                                className={styles['contests-grid__contest-image']}
                            />
                        </div>
                        <div className={styles['contests-grid__contest-title']}>{contest.title}</div>
                        <div className={styles['contests-grid__contest-subtitle']}>{contest.subtitle}</div>
                    </a>
                </AppLink>
            ))}
        </div>
    );
}

export default ContestsGrid;
